module.exports = __webpack_public_path__ + "img/profile.6ae27a32.svg";